const tabConfig = [{
  columnTitle: 'Username',
  dataField: 'USER_ID',
}, {
  columnTitle: 'Engines that he has permission',
  dataField: 'MP_CODE',
}];

export default tabConfig;
